module.exports = __webpack_public_path__ + "media/images/icon-pushkin-fill-dark-2300d5b45c1e7047a56eca1e41469fc0.svg";